/**
 * QuickHook goal options + multi-select helpers.
 * Primary goal drives calorie estimate; all goals enrich the guest version.
 */

export const GOAL_OPTIONS = [
  { key: 'lose_weight', labelKey: 'goals.weight_loss' },
  { key: 'gain_muscle', labelKey: 'goals.gain_muscle' },
  { key: 'eat_better', labelKey: 'goals.eat_better' },
  { key: 'sleep_better', labelKey: 'goals.sleep_better' },
  { key: 'longevity', labelKey: 'goals.longevity' },
  { key: 'mental_wellbeing', labelKey: 'goals.mental_wellbeing' },
  { key: 'more_energy', labelKey: 'goals.more_energy' },
  { key: 'move_better', labelKey: 'goals.move_better' },
];

const ALLOWED = new Set(GOAL_OPTIONS.map((o) => o.key));

/**
 * @param {string|string[]} goalOrGoals
 * @returns {string[]}
 */
export function normalizeGoals(goalOrGoals) {
  const list = Array.isArray(goalOrGoals) ? goalOrGoals : goalOrGoals ? [goalOrGoals] : [];
  return [...new Set(list.map((g) => String(g || '').trim()).filter((g) => ALLOWED.has(g)))];
}

/**
 * First selected goal (user order) — used for calorie target compatibility.
 * @param {string|string[]} goalOrGoals
 * @returns {string}
 */
export function pickPrimaryGoal(goalOrGoals) {
  const list = normalizeGoals(goalOrGoals);
  return list[0] || 'longevity';
}
